export const externalModules = [];

export const externalProviders = [];
